import { useState, type FormEvent } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt');
    if (honeypot && (honeypot as string).trim().length > 0) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const formPayload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt' || !value) {
          formPayload.append(key, value as string);
        }
      });

      const res = await fetch('https://readdy.ai/api/form/d9peib6b4qjhggaepsjg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formPayload.toString(),
      });

      const responseText = await res.text();
      let parsed: any;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，最新韩漫更新将第一时间通知您。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '订阅失败，请稍后再试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('success');
          setMessage('订阅成功！感谢您的关注。');
          setEmail('');
        } else {
          setStatus('error');
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20atmospheric%20illustration%20of%20a%20cozy%20reading%20corner%20with%20bookshelves%20filled%20with%20colorful%20comics%2C%20soft%20warm%20lamp%20light%2C%20comfortable%20armchair%2C%20gentle%20ambient%20lighting%2C%20peaceful%20atmosphere%2C%20cream%20and%20warm%20brown%20tones&width=1920&height=600&seq=cta-bg-comic&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/40 to-black/55"></div>
      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1280px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-3">
          订阅我们的更新通知
        </h2>
        <p className="text-sm md:text-base text-background-200 mb-8 max-w-lg mx-auto">
          第一时间获取最新韩漫上架和热门推荐，精彩内容不错过。
        </p>
        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="请输入您的邮箱地址"
            className="w-full sm:flex-1 px-5 py-3 rounded-full bg-background-50/95 text-foreground-900 placeholder-foreground-400 text-sm outline-none focus:ring-2 focus:ring-primary-400 border border-background-200/50"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
        </form>
        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-300' : 'text-red-300'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}